import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { MimeType } from '@/enums';

@Component
export default class DriveItemsButton extends Vue {
	@Prop() public title!: string;
	@Prop() public hidden!: boolean;
	@Prop() public disabled!: boolean;
	@Prop() public path!: string;
	@Prop() public mimeType!: MimeType;

	public async created(): Promise<void> {
	}

	@Emit("drive-items-button-click")
	public click(path: string, mimeType: MimeType) { }

	// TODO drive itemsをイベントで返してもいいかも
	private onClick(): void {
		if (this.disabled) {
			return;
		}
		this.click(this.path, this.mimeType);
	}
}
